var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilterPrimary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.8889V23.4444H15.6667V21.8889H11ZM11 12.5556V14.1111H18.7778V12.5556H11ZM18.7778 25V23.4444H25V21.8889H18.7778V20.3333H17.2222V25H18.7778ZM14.1111 15.6667V17.2222H11V18.7778H14.1111V20.3333H15.6667V15.6667H14.1111ZM25 18.7778V17.2222H17.2222V18.7778H25ZM20.3333 15.6667H21.8889V14.1111H25V12.5556H21.8889V11H20.3333V15.6667Z",
    fill: "#165EF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterPrimary);
export default __webpack_public_path__ + "static/media/icon-filter-primary.193c97f6ba00b73fe090d7c9f0d6d9d4.svg";
export { ForwardRef as ReactComponent };